
export  const stripePublicKey ='pk_test_51PT4wuF2Y23I3sky4LYZjbqBah1B8C89kkw7R6YUNXjBPhMwE83uEhYvnoVB3gndcpnZ7kxmT6nmRSIGLgDS02qs00FPsPANmq';
                                